export function roundNearest(num, nearest) {
	return Math.round(num / nearest) * nearest
}

export function roundNearest5(num) {
	return roundNearest(num, 5)
}

export function roundUp(num, nearest) {
	return Math.ceil(num / nearest) * nearest
}

export function roundUp5(num) {
	return roundUp(num, 5)
}
